// extracted by mini-css-extract-plugin
export default {"boardView":"Board-module__boardView--IHXJN","Box":"Board-module__Box--EZFVG","OmnibarContainer":"Board-module__OmnibarContainer--DI7Wi"};